import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

export interface Notification {
    id?: number;
    idCliente: number;
    title: string;
    body: string;
    icon: string;
    url: string;
    cardType?: string;
    cardId?: number;
    createdAt?: string;
    read?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor(private http: HttpClient) { }

    public getNotifications(idCliente: number, cardType?: string, cardId?: number): Observable<Notification[]> {
        let params = new HttpParams().set('idCliente', idCliente.toString());

        if (cardType) {
            params = params.set('cardType', cardType);
        }
        if (cardId) {
            params = params.set('cardId', cardId.toString());
        }

        return this.http.get<Notification[]>(`${environment.apiEndpoint}api/notifications`, { params });
    }

    public sendNotification(notification: any): Observable<any> {
        return this.http.post(`${environment.apiEndpoint}api/notifications/send`, notification);
    }
}

